'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _expiredSessionModal = require('../actions/expired-session-modal');

var _doctifyUtils = require('doctify-utils');

var INITIAL_STATE = {
	isOpen: false
};

var expiredSessionModal = function expiredSessionModal(state, action) {
	switch (action.type) {
		case _expiredSessionModal.CLOSE:
			return Object.assign({}, state, { isOpen: false });
		case _doctifyUtils.UNAUTHORIZED:
			return Object.assign({}, state, { isOpen: true });
		default:
			return state || INITIAL_STATE;
	}
};

exports.default = expiredSessionModal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/reducers/expired-session-modal.js
// module id = 1693
// module chunks = 0